import { useIntl } from 'react-intl'
import { connect, useDispatch, useSelector } from 'react-redux'
import SectionContainer from '../../Layout/SectionContainer/SectionContainer'
import Action from '../Action/Action'
import { NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE } from '@/app/redux/reducers/activity-creation'
import {
    ActivitySection,
    NewActivitySectionType,
    NewSurveyTaskStepNavigation,
} from '@/app/models/new-activity-section-type'
import {
    addChangelog,
    createSurveyTask,
    editProject,
    historyChange,
    NewActivityCreationActions,
    removeChangelog,
    setActivitySectionStatus,
    setCtaTemplate,
    setCurrentStep,
    setIsActivityTypeStep,
    setNewActivityForm,
    setQuestionStatus,
    setResetMandatory,
    setSelectedActivityType,
    setSurveyStatus,
    setTaskStatus,
} from '@/app/redux/actions/activity-creation'
import { ActivityStep, Question, Survey, Task } from '@/app/models/new-activity-creation-state'
import {
    FormField,
    MainInfoForm,
    PointsAssignmentForm,
    SchedulingForm,
    TaskForm,
} from '@/app/models/new-activity-form'
import { useEffect, useState } from 'react'
import { creationSurveyTaskCta, editCta } from '@/app/models/new-activity-creation-cta'
import {
    Analytics,
    AppState,
    LayoutActivityType,
    SmartlyActionItems,
} from '@Techedge/digitalportal-shared'
import EditingReason from '../EditingReason/EditingReason'
import { getDateDiff } from '@/app/utils/activityAdapter'
import { ProjectApiCreateActivityBody, ProjectApiStatus } from '@/app/models/projects-service'
import DialogDuplicate from '../../UI/Dialogs/DialogDuplicate/DialogDuplicate'
import { CtaGroupWrapper } from '../../UI/CtaGroup/CtaGroupWrapper'
import { cancelProject } from '@/app/redux/actions/activity-execution'
import DialogHistoryChange from '../../UI/Dialogs/DialogHistoryChange/DialogHistoryChange'
import DialogResetStore from '../../UI/Dialogs/DialogResetStore/DialogResetStore'
import { creationAnalyticsPageTypeMap } from '@/app/models/analyticsPageTypeMap'
import SurveyTaskScheduling from './SurveyTaskScheduling/SurveyTaskScheduling'
import SurveyTaskMainInfo from './SurveyTaskMainInfo/SurveyTaskMainInfo'
import { ProjectsService } from '@/app/services/ProjectsService'
import { getCreateSurveyTaskBody, getEditSurveyTaskBody } from './adapter'
import './NewActivitySurveyTask.scss'
import { Color, LuxButton } from '@lux/wardrobe-lib'
import SectionBox from '../../Layout/SectionBox/SectionBox'
import { selectCurrentStep } from '@/app/redux/selector/activity-creation'
import { SectionFilter } from '@/app/models/search'
import { PointsAssignments } from '../PointsAssignment/PointsAssignments'
import { selectProjectDetails } from '@/app/redux/selector/activity-execution'

const NewActivitySurveyTask = (props: any) => {
    const {
        form,
        setForm,
        sectionMap,
        setActivitySectionStatus,
        projectVisibilityOptions,
        setCtaTemplate,
        questionList,
        taskList,
        surveyList,
        setActionTaskList,
        setActionQuestionList,
        setActionSurveyList,
        isEdit,
        createProject,
        cancelProject,
        historyChange,
        changeFields,
        editProject,
        isResetMandatory,
        setResetMandatory,
        visitProps,
        closeNewActivity,
    } = props

    const intl = useIntl()
    const dispatch = useDispatch()
    const step = useSelector(selectCurrentStep)
    const projectDetails = useSelector(selectProjectDetails)
    const hasSocialHubEnabled = useSelector(
        (state: AppState) => state.userReducer.user.phase3_enabled
    )

    const componentClass = 'smart-new-activity-survey-task'

    const [showDuplicateDialog, setShowDuplicateDialog] = useState(false)
    const [showHistoryChangeDialog, setShowHistoryChangeDialog] = useState(false)

    const [reasonWhy, setReasonWhy] = useState('')
    const [editingReason, setEditingReason] = useState('')
    const [messageForStores, setMessageForStore] = useState('')

    const [editStatusAction, setEditStatusAction] = useState('')

    const ctaHandler = (action: string, form) => {
        switch (action) {
            case NewActivityCreationActions.CREATE_AS_TO_BE_RELEASED:
                createProject({
                    form: getCreateSurveyTaskBody({
                        form,
                        status: ProjectApiStatus.NEW,
                        projectType: SmartlyActionItems.TASK,
                        visitProps,
                    }),
                    successMessage: intl.formatMessage({
                        id: 'modals.activity.create.conclude.success.message',
                        defaultMessage: 'Project created successfully!',
                    }),
                    callback: closeNewActivity,
                })
                break
            case NewActivityCreationActions.CLONE:
                setShowDuplicateDialog(true)
                break
            case NewActivityCreationActions.CANCEL:
                cancelProject(
                    projectDetails._id,
                    intl.formatMessage({
                        id: 'modals.activity.approval.cancel.success.message',
                        defaultMessage: 'Store redo successfully!',
                    })
                )
                break
            case NewActivityCreationActions.HISTORY_CHANGE:
                historyChange(
                    getEditSurveyTaskBody({
                        form: {
                            ...form,
                            questionList,
                            taskList,
                        },
                        status: ProjectApiStatus.NEW,
                        projectType: SmartlyActionItems.TASK,
                        visitProps,
                        projectDetails,
                    })
                )
                Analytics._sendAnalyticsLinkEvent(
                    'Activities',
                    creationAnalyticsPageTypeMap[projectDetails.projectType][projectDetails.module]
                        .history,
                    'Static'
                )
                setShowHistoryChangeDialog(true)
                break
            case NewActivityCreationActions.EDIT_RELEASE:
                setEditStatusAction('released')
                historyChange(
                    getEditSurveyTaskBody({
                        form: {
                            ...form,
                            questionList,
                            taskList,
                        },
                        status: ProjectApiStatus.NEW,
                        projectType: SmartlyActionItems.TASK,
                        visitProps,
                        projectDetails,
                    }),
                    true,
                    reasonWhy,
                    editingReason,
                    messageForStores,
                    intl.formatMessage({
                        id: 'modals.activity.create.edit.success.message',
                        defaultMessage: 'Project edit successfully!',
                    }),
                    'released'
                )
                break
        }
    }

    const handlerEditProject = (confirm) => {
        if (!confirm) {
            setResetMandatory(false)
            return
        }

        const newProjectDetails = getEditSurveyTaskBody({
            form: {
                ...form,
                questionList,
                taskList,
            },
            status: ProjectApiStatus.NEW,
            projectType: SmartlyActionItems.TASK,
            visitProps,
            projectDetails,
        })
        editProject(
            newProjectDetails,
            reasonWhy,
            editingReason,
            messageForStores,
            intl.formatMessage({
                id: 'modals.activity.create.edit.success.message',
                defaultMessage: 'Project edit successfully!',
            }),
            editStatusAction
        )
    }

    const onDuplicateConfirm = (confirm: boolean) => {
        if (confirm) {
            setActivitySectionStatus(
                ActivitySection.SURVEY_TASK_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: false }
            )
            taskList.map((task, index) => {
                setActionTaskList(index, {
                    ...task,
                    startDate: null,
                    endDate: null,
                })
            })
            surveyList.map((survey, index) => {
                setActionSurveyList(index, {
                    ...survey,
                    startDate: null,
                    endDate: null,
                })
            })
            setForm(
                {
                    title: {
                        ...form[NewActivitySectionType.MAIN_INFO].title,
                        value: `${form[NewActivitySectionType.MAIN_INFO].title.value} - Copy`,
                    },
                },
                NewActivitySectionType.MAIN_INFO,
                ActivitySection.SURVEY_TASK_ACTIVITY
            )
            setForm(
                {
                    startDate: {
                        ...form[NewActivitySectionType.SCHEDULING].startDate,
                        value: null,
                    },
                    endDate: {
                        ...form[NewActivitySectionType.SCHEDULING].endDate,
                        value: null,
                    },
                    specificDate: {
                        ...form[NewActivitySectionType.SCHEDULING].specificDate,
                        value: null,
                    },
                },
                NewActivitySectionType.SCHEDULING,
                ActivitySection.SURVEY_TASK_ACTIVITY
            )
        }
        setShowDuplicateDialog(false)
    }

    useEffect(() => {
        const disabled = false
        if (isEdit) {
            setActivitySectionStatus(
                ActivitySection.SURVEY_TASK_ACTIVITY,
                NewActivitySectionType.EDITING_REASON,
                { isDone: projectDetails?.reasonChange?.value?.length > 0 }
            )
            setActivitySectionStatus(
                ActivitySection.SURVEY_TASK_ACTIVITY,
                NewActivitySectionType.MAIN_INFO,
                { isDone: true }
            )
            setActivitySectionStatus(
                ActivitySection.SURVEY_TASK_ACTIVITY,
                NewActivitySectionType.ACTION,
                {
                    isDone: true,
                    isDirty: isEdit,
                }
            )
            setActivitySectionStatus(
                ActivitySection.SURVEY_TASK_ACTIVITY,
                NewActivitySectionType.POINTS_ASSIGNMENT,
                { isDone: isEdit && !!projectDetails.badge }
            )
            setActivitySectionStatus(
                ActivitySection.SURVEY_TASK_ACTIVITY,
                NewActivitySectionType.SCHEDULING,
                { isDone: isEdit, isDirty: isEdit }
            )
            const attachments = []
            if (!!projectDetails.attachments)
                projectDetails.attachments.forEach((attachment) => {
                    if (attachment)
                        attachments.push({
                            _id: attachment._id,
                            file: attachment,
                            url: !!attachment && attachment.url,
                        })
                })
            setForm(
                {
                    title: {
                        ...form[NewActivitySectionType.MAIN_INFO].title,
                        value: projectDetails.projectTitle,
                        disabled,
                    },
                    department: {
                        ...form[NewActivitySectionType.MAIN_INFO].department,
                        value: projectDetails.department,
                        disabled,
                    },
                    recipient: {
                        ...form[NewActivitySectionType.MAIN_INFO].recipient,
                        value: projectDetails.assignment && projectDetails.assignment[0],
                        disabled: true,
                    },
                    username: {
                        ...form[NewActivitySectionType.MAIN_INFO].username,
                        value: projectDetails.assigneeId,
                        disabled: true,
                    },
                    info: {
                        ...form[NewActivitySectionType.MAIN_INFO].info,
                        value: projectDetails.information,
                        disabled,
                    },
                    attachmentList: {
                        ...form[NewActivitySectionType.MAIN_INFO].attachmentList,
                        value: [...attachments],
                        disabled,
                    },
                    confirmRead: {
                        ...form[NewActivitySectionType.MAIN_INFO].confirmRead,
                        value: projectDetails.requiredConfirmReading,
                        disabled,
                    },
                    messagingEnabled: {
                        ...form[NewActivitySectionType.MAIN_INFO].messagingEnabled,
                        value: projectDetails.enableMessaging,
                        disabled,
                    },
                    commentReaction: {
                        ...form[NewActivitySectionType.MAIN_INFO].commentReaction,
                        disabled,
                    },
                    storeId: {
                        value: projectDetails.storesIdList && projectDetails.storesIdList[0],
                    },
                },
                NewActivitySectionType.MAIN_INFO,
                ActivitySection.SURVEY_TASK_ACTIVITY
            )
            setForm(
                {
                    badge: {
                        ...form[NewActivitySectionType.POINTS_ASSIGNMENT].badge,
                        value: {
                            id: projectDetails.badge?._id,
                            points: projectDetails.badge?.points,
                        },
                    },
                    points: {
                        ...form[NewActivitySectionType.POINTS_ASSIGNMENT].badge,
                        value: projectDetails.badge?.activityPoints,
                    },
                },
                NewActivitySectionType.POINTS_ASSIGNMENT,
                ActivitySection.SURVEY_TASK_ACTIVITY
            )
            setForm(
                {
                    startDate: {
                        ...form[NewActivitySectionType.SCHEDULING].startDate,
                        value: new Date(projectDetails.startDate),
                        disabled,
                    },
                    endDate: {
                        ...form[NewActivitySectionType.SCHEDULING].endDate,
                        value: new Date(projectDetails.endDate),
                        disabled,
                    },
                    projectVisibility: {
                        ...form[NewActivitySectionType.SCHEDULING].projectVisibility,
                        value: projectDetails.visibility,
                        disabled,
                    },
                    daysBefore: {
                        ...form[NewActivitySectionType.SCHEDULING].daysBefore,
                        value: getDateDiff(projectDetails.visibilityDate, projectDetails.startDate),
                        disabled,
                    },
                    specificDate: {
                        ...form[NewActivitySectionType.SCHEDULING].specificDate,
                        value:
                            projectDetails.visibility === 'specificDate'
                                ? new Date(projectDetails.visibilityDate)
                                : null,
                        disabled,
                    },
                    priority: {
                        ...form[NewActivitySectionType.SCHEDULING].priority,
                        value: projectDetails.priority,
                        disabled,
                    },
                    autoClose: {
                        ...form[NewActivitySectionType.SCHEDULING].autoClose,
                        value: projectDetails.autoclose,
                        disabled,
                    },
                    autoCloseDays: {
                        ...form[NewActivitySectionType.SCHEDULING].autoCloseDays,
                        value: getDateDiff(projectDetails.endDate, projectDetails.autocloseDate),
                        disabled,
                    },
                    calendarVisibility: {
                        ...form[NewActivitySectionType.SCHEDULING].calendarVisibility,
                        value: !!projectDetails.visibilityCalendar
                            ? projectDetails.visibilityCalendar
                            : form[NewActivitySectionType.SCHEDULING].calendarVisibility.value,
                        disabled,
                    },
                },
                NewActivitySectionType.SCHEDULING,
                ActivitySection.SURVEY_TASK_ACTIVITY
            )
            setForm(
                {
                    reasonWhy: { value: projectDetails.reasonChoice },
                    editingReason: { value: projectDetails.reasonChange },
                    messageForStores: { value: projectDetails.messageStores },
                },
                NewActivitySectionType.EDITING_REASON,
                ActivitySection.SURVEY_TASK_ACTIVITY
            )

            setReasonWhy(projectDetails.reasonChoice)
            setEditingReason(projectDetails.reasonChange)
            setMessageForStore(projectDetails.messageStores)

            const projectDetailsQuestions =
                projectDetails?.storesList?.length > 0 &&
                projectDetails?.storesList[0]?.questionsStores?.length > 0
                    ? projectDetails?.storesList[0]?.questionsStores[0]?.questionStore || []
                    : []
            const projectDetailsJobs =
                projectDetails?.storesList?.length > 0 &&
                projectDetails?.storesList[0]?.jobsStores?.length > 0
                    ? projectDetails?.storesList[0]?.jobsStores[0]?.jobStore || []
                    : []
            projectDetailsJobs.forEach((task, index) => {
                let newJob: any = {
                    title: task.title,
                    description: task.details,
                    urgent: task.priority === 'urgent',
                    attachmentList: task.attachments
                        ? task.attachments.map((attachment) => ({
                              _id: attachment._id,
                              file: attachment,
                              url: !!attachment && attachment.url,
                              hideEyeIcon: true,
                          }))
                        : [],
                    questionList: task.questions.map((question) => {
                        let newQuestion: any = {
                            type: question.questionType,
                            text: question.questionTitle,
                            mandatoryAttachment: question.attachmentsRequired,
                            answerList: question.possibleAnswers.map((a) => ({
                                value: a,
                            })),
                            isDone: true,
                            // _id: question._id,
                            attachmentList: question.attachments
                                ? question.attachments.map((attachment) => ({
                                      _id: attachment._id,
                                      file: attachment,
                                      url: !!attachment && attachment.url,
                                      hideEyeIcon: true,
                                  }))
                                : [],
                        }
                        if (isEdit) newQuestion._id = question._id
                        return newQuestion
                    }),
                    startDate: new Date(task.startDate),
                    endDate: new Date(task.endDate),
                    recipient: projectDetails?.jobs[index].assignment,
                    isDone: true,
                }
                if (isEdit) newJob._id = task._id
                setActionTaskList(index, newJob)
            })
            projectDetailsQuestions.forEach((question, index) => {
                let newQuestion: any = {
                    type: question.questionType,
                    text: question.questionTitle,
                    mandatoryAttachment: question.attachmentsRequired,
                    answerList: question.possibleAnswers.map((a) => ({
                        value: a,
                    })),
                    attachmentList: question.attachments
                        ? question.attachments.map((attachment) => ({
                              _id: attachment._id,
                              file: attachment,
                              url: !!attachment && attachment.url,
                              hideEyeIcon: true,
                          }))
                        : [],
                    isDone: true,
                }
                if (isEdit) newQuestion._id = question._id
                setActionQuestionList(index, newQuestion)
            })
        }
    }, [projectDetails])

    const isFormValid = () => {
        const badgeDisabled =
            !hasSocialHubEnabled ||
            (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id)
        const badgePoints =
            form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.points ||
            Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value)
        return (
            !!form[NewActivitySectionType.MAIN_INFO].title.value &&
            !!form[NewActivitySectionType.MAIN_INFO].department.value &&
            !!form[NewActivitySectionType.MAIN_INFO].recipient.value &&
            !!form[NewActivitySectionType.MAIN_INFO].username.value &&
            (badgeDisabled ||
                (Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) > 0 &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) <=
                        badgePoints)) &&
            !!form[NewActivitySectionType.SCHEDULING].startDate.value &&
            !!form[NewActivitySectionType.SCHEDULING].endDate.value &&
            !!form[NewActivitySectionType.SCHEDULING].projectVisibility.value &&
            !!form[NewActivitySectionType.SCHEDULING].priority.value &&
            !questionList.filter((q) => !q.isDone).length &&
            !taskList.filter((t) => !t.isDone || !t.startDate || !t.endDate).length &&
            !surveyList.filter((s) => !s.isDone || !s.startDate || !s.endDate).length &&
            (projectDetails?.status === 'draft' ||
                projectDetails?.status === 'rejected' ||
                !isEdit ||
                (isEdit && reasonWhy && editingReason))
        )
    }

    const onNextStep = () => {
        if (
            step === NewActivitySectionType.DISTRIBUTION &&
            (!hasSocialHubEnabled ||
                (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id))
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.SCHEDULING))
            return
        }
        dispatch(setCurrentStep(NewSurveyTaskStepNavigation[step].next))
    }
    const onBackStep = () => {
        if (step === NewActivitySectionType.EDITING_REASON) {
            dispatch(setSelectedActivityType({ key: LayoutActivityType.TASK }))
            dispatch(setIsActivityTypeStep(true))
            dispatch(setCurrentStep(NewActivitySectionType.ACTIVITY_TYPE))
            return
        }
        if (
            !NewSurveyTaskStepNavigation[step].back &&
            isEdit &&
            projectDetails?.status !== SectionFilter.draft &&
            projectDetails?.status !== SectionFilter.rejected
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.EDITING_REASON))
            return
        }
        if (
            step === NewActivitySectionType.SCHEDULING &&
            (!hasSocialHubEnabled ||
                (isEdit && !form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.id))
        ) {
            dispatch(setCurrentStep(NewActivitySectionType.DISTRIBUTION))
            return
        }
        if (!NewSurveyTaskStepNavigation[step].back) {
            dispatch(setSelectedActivityType({ key: LayoutActivityType.TASK }))
            dispatch(setIsActivityTypeStep(true))
            dispatch(setCurrentStep(NewActivitySectionType.ACTIVITY_TYPE))
            return
        }
        dispatch(setCurrentStep(NewSurveyTaskStepNavigation[step].back))
    }

    useEffect(() => {
        dispatch(
            setCurrentStep(
                isEdit &&
                    projectDetails?.status !== SectionFilter.draft &&
                    projectDetails?.status !== SectionFilter.rejected
                    ? NewActivitySectionType.EDITING_REASON
                    : NewActivitySectionType.MAIN_INFO
            )
        )
    }, [])

    useEffect(() => {
        if (step !== NewActivitySectionType.SCHEDULING) {
            let back = <div></div>
            if (
                (!isEdit && step !== NewActivitySectionType.MAIN_INFO) ||
                (isEdit && step !== NewActivitySectionType.EDITING_REASON)
            ) {
                back = (
                    <LuxButton
                        text={intl.formatMessage({
                            id: 'back',
                            defaultMessage: 'Back',
                        })}
                        variant="text"
                        color={Color.BLACK}
                        onClick={onBackStep}
                    />
                )
            }
            setCtaTemplate(
                <div className={`${componentClass}__cta-step`}>
                    {back}
                    <div className={`${componentClass}__cta-step-right`}>
                        <LuxButton
                            text={intl.formatMessage({
                                id: 'next',
                                defaultMessage: 'Next',
                            })}
                            color={Color.BLACK}
                            onClick={onNextStep}
                            disabled={!sectionMap[step]?.isDone}
                        />
                    </div>
                </div>
            )
        }
    }, [step, sectionMap, form])

    useEffect(() => {
        // PERMISSION CTA
        const ctaConfig = !isEdit
            ? creationSurveyTaskCta(
                  SmartlyActionItems.TASK,
                  projectDetails?._id ? projectDetails : { type: 'surveyTask' }
              ).setDisableConditions([
                  {
                      action: NewActivityCreationActions.CREATE_AS_TO_BE_RELEASED,
                      disableCondition: !isFormValid(),
                  },
              ])
            : editCta(
                  SmartlyActionItems.TASK,
                  projectDetails?._id ? projectDetails : { type: 'surveyTask' }
              ).setDisableConditions([
                  {
                      action: NewActivityCreationActions.EDIT_RELEASE,
                      disableCondition: !isFormValid(),
                  },
              ])
        const newForm = { ...form, questionList, taskList, surveyList }

        if (step === NewActivitySectionType.SCHEDULING) {
            setCtaTemplate(
                <div className={`${componentClass}__cta-step`}>
                    <LuxButton
                        text="Back"
                        variant="text"
                        color={Color.BLACK}
                        onClick={onBackStep}
                    />
                    <CtaGroupWrapper
                        ctaConfig={ctaConfig}
                        componentClass={componentClass}
                        ctaHandler={(action) => ctaHandler(action, newForm)}
                    />
                </div>
            )
        }
    }, [form, questionList, taskList, projectDetails, reasonWhy, editingReason])

    useEffect(() => {
        const isDone =
            Object.values(form[NewActivitySectionType.MAIN_INFO]).filter(
                (field: FormField<any>) => field.mandatory && !field.value
            ).length === 0
        setActivitySectionStatus(
            ActivitySection.SURVEY_TASK_ACTIVITY,
            NewActivitySectionType.MAIN_INFO,
            {
                isDone,
            }
        )
    }, [form[NewActivitySectionType.MAIN_INFO]])

    useEffect(() => {
        const isDone =
            !questionList.filter((q) => !q.isDone).length &&
            !taskList.filter((t) => !t.isDone || !t.startDate || !t.endDate).length &&
            !surveyList.filter((s) => !s.isDone || !s.startDate || !s.endDate).length
        setActivitySectionStatus(
            ActivitySection.SURVEY_TASK_ACTIVITY,
            NewActivitySectionType.ACTION,
            {
                isDone: isDone && sectionMap[NewActivitySectionType.ACTION].isDirty,
            }
        )
    }, [questionList, taskList, surveyList])

    useEffect(() => {
        setForm(
            {
                reasonWhy: {
                    value: reasonWhy?.length > 0 ? reasonWhy : projectDetails?.reasonChoice,
                },
                editingReason: {
                    value: editingReason?.length > 0 ? editingReason : projectDetails?.reasonChange,
                },
                messageForStores: {
                    value:
                        messageForStores?.length > 0
                            ? messageForStores
                            : projectDetails?.messageStores,
                },
            },
            NewActivitySectionType.EDITING_REASON,
            ActivitySection.SURVEY_TASK_ACTIVITY
        )

        let isDone = false

        if (editingReason?.length > 0 && reasonWhy?.length > 0) {
            isDone = true
        }

        setActivitySectionStatus(
            ActivitySection.SURVEY_TASK_ACTIVITY,
            NewActivitySectionType.EDITING_REASON,
            { isDone }
        )
    }, [reasonWhy, editingReason, messageForStores])

    useEffect(() => {
        const badgePoints =
            form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value?.points ||
            Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value)
        setActivitySectionStatus(
            ActivitySection.SURVEY_TASK_ACTIVITY,
            NewActivitySectionType.POINTS_ASSIGNMENT,
            {
                isDone:
                    !!form[NewActivitySectionType.POINTS_ASSIGNMENT].badge.value &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) > 0 &&
                    Number(form[NewActivitySectionType.POINTS_ASSIGNMENT].points.value) <=
                        badgePoints,
            }
        )
    }, [form[NewActivitySectionType.POINTS_ASSIGNMENT]])

    const onAction = () => {
        setActivitySectionStatus(
            ActivitySection.SURVEY_TASK_ACTIVITY,
            NewActivitySectionType.ACTION,
            {
                isDirty: true,
                isDone: false,
            }
        )
    }

    const onSectionSave = (sectionKey: NewActivitySectionType) => {
        setActivitySectionStatus(ActivitySection.SURVEY_TASK_ACTIVITY, sectionKey, { isDone: true })
    }

    const onMainInfoChange = (partialForm: Partial<MainInfoForm>) => {
        setForm(partialForm, NewActivitySectionType.MAIN_INFO, ActivitySection.SURVEY_TASK_ACTIVITY)
    }

    const onPointsAssignment = (partialForm: Partial<PointsAssignmentForm>) => {
        setForm(
            partialForm,
            NewActivitySectionType.POINTS_ASSIGNMENT,
            ActivitySection.SURVEY_TASK_ACTIVITY
        )
    }

    const onSchedulingChange = (partialForm: Partial<SchedulingForm>) => {
        setForm(
            partialForm,
            NewActivitySectionType.SCHEDULING,
            ActivitySection.SURVEY_TASK_ACTIVITY
        )
        let isDone
        if (
            partialForm.startDate.value &&
            partialForm.endDate.value &&
            partialForm.priority.value &&
            partialForm.projectVisibility.value &&
            (partialForm.projectVisibility.value !== projectVisibilityOptions[3].value ||
                (partialForm.projectVisibility.value === projectVisibilityOptions[3].value &&
                    partialForm.specificDate.value))
        )
            isDone = true
        setActivitySectionStatus(
            ActivitySection.SURVEY_TASK_ACTIVITY,
            NewActivitySectionType.SCHEDULING,
            {
                isDone,
            }
        )
    }

    useEffect(() => {
        if (!isEdit) {
            ProjectsService.GetProjectDetails(visitProps.visit_id, []).then((res) => {
                if (res && res.data) {
                    onMainInfoChange({
                        ...form[NewActivitySectionType.MAIN_INFO],
                        storeId: {
                            value: res.data.storesIdList[0],
                        },
                    })
                }
            })
        }
    }, [])

    return (
        <div className={componentClass}>
            <SectionContainer>
                {step === NewActivitySectionType.EDITING_REASON &&
                    !!projectDetails &&
                    projectDetails?.status !== 'draft' &&
                    projectDetails?.status !== 'rejected' && (
                        <SectionBox
                            title={intl.formatMessage({
                                id: 'modals.new.activity.task.section.editing.reason',
                                defaultMessage: 'Editing Reason',
                            })}>
                            <EditingReason
                                projectType={projectDetails?.projectType}
                                reasonWhy={reasonWhy}
                                editingReason={editingReason}
                                messageForStores={messageForStores}
                                onReasonWhy={setReasonWhy}
                                onEditingReason={setEditingReason}
                                onMessage={setMessageForStore}
                            />
                        </SectionBox>
                    )}
                {step === NewActivitySectionType.MAIN_INFO && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.main.info',
                            defaultMessage: 'Main Information',
                        })}>
                        <SurveyTaskMainInfo
                            form={form[NewActivitySectionType.MAIN_INFO]}
                            onSetForm={(form) => onMainInfoChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.MAIN_INFO)}
                            isDone={sectionMap[NewActivitySectionType.MAIN_INFO].isDone}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.ACTION &&
                    !sectionMap[NewActivitySectionType.ACTION].isHide && (
                        <SectionBox
                            title={intl.formatMessage({
                                id: 'modals.new.activity.section.action',
                                defaultMessage: 'Action',
                            })}>
                            <Action
                                disableSurveys
                                section={sectionMap[NewActivitySectionType.ACTION]}
                                questionList={questionList}
                                onSave={() => onSectionSave(NewActivitySectionType.ACTION)}
                                onAction={onAction}
                            />
                        </SectionBox>
                    )}
                {step === NewActivitySectionType.POINTS_ASSIGNMENT && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.points.assignment',
                            defaultMessage: 'Points Assignment',
                        })}>
                        <PointsAssignments
                            form={form.pointsAssignment}
                            storeIds={[{ store_id: form[NewActivitySectionType.MAIN_INFO].storeId.value }]}
                            onSetForm={onPointsAssignment}
                            isDone={sectionMap[NewActivitySectionType.POINTS_ASSIGNMENT].isDone}
                        />
                    </SectionBox>
                )}
                {step === NewActivitySectionType.SCHEDULING && (
                    <SectionBox
                        title={intl.formatMessage({
                            id: 'modals.new.activity.section.scheduling',
                            defaultMessage: 'Scheduling',
                        })}>
                        <SurveyTaskScheduling
                            form={form[NewActivitySectionType.SCHEDULING]}
                            onSetForm={(form) => onSchedulingChange(form)}
                            onSave={() => onSectionSave(NewActivitySectionType.SCHEDULING)}
                            isDone={sectionMap[NewActivitySectionType.SCHEDULING].isDone}
                        />
                    </SectionBox>
                )}
            </SectionContainer>
            <DialogDuplicate
                dialogVisible={showDuplicateDialog}
                onSave={onDuplicateConfirm}
                onHide={() => setShowDuplicateDialog(false)}
            />
            <DialogHistoryChange
                dialogVisible={showHistoryChangeDialog}
                onHide={() => setShowHistoryChangeDialog(false)}
                changeFields={changeFields}
                timezone={projectDetails?.timeZone}
            />
            {isResetMandatory && (
                <DialogResetStore
                    dialogVisible={isResetMandatory}
                    onHide={() => setResetMandatory(false)}
                    onSave={(confirm) => handlerEditProject(confirm)}
                    changeFields={changeFields}
                    storesList={[
                        {
                            _id: projectDetails._id,
                            status: projectDetails.storesList[0].status || SectionFilter.new,
                            storeId: projectDetails.storesList[0].storeId,
                            storeName: projectDetails.storesList[0].storeName,
                        },
                    ]}
                    timezone={projectDetails?.timeZone}
                />
            )}
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    sectionMap: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].surveyTaskActivity.sectionMap,
    form: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE][ActivitySection.SURVEY_TASK_ACTIVITY].form,
    projectVisibilityOptions:
        state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].projectVisibilityOptions,
    questionList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].questionList,
    taskList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].taskList,
    surveyList: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].surveyList,
    isEdit: state.layoutReducer.modals.props?.isEdit,
    changeFields: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].changeFields,
    isResetMandatory: state[NEW_ACTIVITY_CREATION_REDUCER_NAMESPACE].isResetMandatory,
})

const mapDispatchToProps = (dispatch: any) => ({
    setActivitySectionStatus: (
        activityKey: string,
        sectionKey: NewActivitySectionType,
        section: Partial<ActivityStep>
    ) => dispatch(setActivitySectionStatus(activityKey, sectionKey, section)),
    setForm: (form: TaskForm, section: NewActivitySectionType, activityName: ActivitySection) =>
        dispatch(setNewActivityForm<TaskForm>(form, section, activityName)),
    setCtaTemplate: (template) => dispatch(setCtaTemplate(template)),
    setActionTaskList: (index: number, task: Partial<Task>) => dispatch(setTaskStatus(index, task)),
    setActionQuestionList: (index: number, question: Partial<Question>) =>
        dispatch(setQuestionStatus(index, question)),
    setActionSurveyList: (index: number, survey: Partial<Survey>) =>
        dispatch(setSurveyStatus(index, survey)),
    addChangelog: (changelog: Record<string, string>) => dispatch(addChangelog(changelog)),
    removeChangelog: (field: string) => dispatch(removeChangelog(field)),
    createProject: (params: {
        form: ProjectApiCreateActivityBody
        successMessage: string
        callback: () => void
    }) => dispatch(createSurveyTask(params)),
    cancelProject: (projectId: string, successMessage: string) =>
        dispatch(cancelProject(projectId, successMessage)),
    historyChange: (
        newProject: any,
        invokeEditApi?: boolean,
        reasonChoice?: string[],
        reasonChange?: string,
        messageStores?: string,
        successMessage?: string,
        statusAction?: string
    ) =>
        dispatch(
            historyChange(
                newProject,
                invokeEditApi,
                reasonChoice,
                reasonChange,
                messageStores,
                successMessage,
                statusAction
            )
        ),
    editProject: (
        newProject: any,
        reasonChoice: string[],
        reasonChange: string,
        messageStores: string,
        successMessage: string,
        statusAction?: string
    ) =>
        dispatch(
            editProject(
                newProject,
                reasonChoice,
                reasonChange,
                messageStores,
                successMessage,
                statusAction
            )
        ),
    setResetMandatory: (value: boolean) => dispatch(setResetMandatory(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(NewActivitySurveyTask)
